<footer class="flex justify-end bg-zinc-100 py-12 px-4 sm:px-8 md:px-16 lg:px-36">
  <img class="h-15" src="images/footer-logo.png" alt="" />
</footer>
